import StandQuestion from "./components/StandQuestion";
import SimilarQuestion from "./components/SimilarQuestion";
import LangSelect from "@/components/langSelect";
import i18n from "@/i18n";

export const quesListTable = () => {
    return {
        columns: [
            {
                colId: "questionId",
                header: i18n.t("zhiji.knowlege.standQuestionId"),
                width: "180px"
            },
            {
                component: StandQuestion,
                colId: "standQuestion",
                header: i18n.t("zhiji.knowlege.standQustion"),
                type: "StandQuestion",
                width: "360px"
            },
            {
                width: "100px",
                colId: "language",
                header: i18n.t("zhiji.knowlege.language"),
                type: "Text",
            },
            {
                type: "Text",
                colId: "indexScore",
                header: i18n.t("zhiji.knowlege.matchingFactor"),
                tooltip: i18n.t("zhiji.knowlege.matchingFactorTip")
            },
            {
                type: "Text",
                colId: "score",
                header: i18n.t("zhiji.knowlege.recallScore"),
                tooltip: i18n.t("zhiji.knowlege.recallScoreTip")
            },
            {
                type: "Text",
                colId: "answerNumber",
                header: i18n.t("zhiji.knowlege.answerNumber"),
                width: "80px"
            },
            {
                component: SimilarQuestion,
                colId: "similarQuestion",
                header: i18n.t("zhiji.knowlege.similarQuestions"),
                width: "80px"
            },
            {
                type: "Status",
                colId: "statusLabel",
                header: i18n.t("zhiji.common.status"),
                width: "106px"
            },
            {
                colId: "creator",
                header: i18n.t("zhiji.common.createTime"),
                type: "LineBreakText",
                width: "160px",
            },
            {
                colId: "editor",
                header: i18n.t("zhiji.knowlege.releaseTime"),
                type: "LineBreakText",
                width: "160px"
            }
        ],
        pageLength: 10
    };
};

export const searchFilter = (channel, lang) => [
    {
        props: {
            name: "matchFilterFields",
            inline: true
        },
        uId: "0",
        cid: "Form",
        events: [],
        children: [
            {
                props: {
                    style: {
                        width: "140px"
                    },
                    clearable: true,
                    placeholder: i18n.t("zhiji.knowlege.choseAnswerChannel"),
                    options: channel.map(item => ({ label: item, value: item })),
                    value: "",
                    name: "channel"
                },
                uId: "1",
                cid: "Elselector",
                events: [],
                children: []
            },
            {
                props: {
                    style: {
                        width: "140px"
                    },
                    clearable: true,
                    placeholder: i18n.t("zhiji.knowlege.choseClientLang"),
                    options: lang.map(item => ({ label: item, value: item })),
                    value: "",
                    name: "lang"
                },
                uId: "2",
                cid: LangSelect,
                events: [],
                children: []
            },
            {
                props: {
                    style: {
                        width: "500px"
                    },
                    placeholder: i18n.t("zhiji.knowlege.keyWords"),
                    name: "question",
                    needTrim: false,
                    clearable: true
                },
                uId: "3",
                cid: "TextInput",
                events: [],
                children: []
            },
            {
                props: {
                    name: "btn",
                    btnText: i18n.t("zhiji.knowlege.queryTxt"),
                },
                uId: "4",
                cid: "CountButton",
                events: [],
                children: []
            }
        ]
    }
];
